/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratornonemployeerelated4Inputs */

const en_settings_collaborators_invitecollaboratornonemployeerelated4 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratornonemployeerelated4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-employee related`)
};

/**
* | output |
* | --- |
* | "Non-employee related" |
*
* @param {Settings_Collaborators_Invitecollaboratornonemployeerelated4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratornonemployeerelated4 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratornonemployeerelated4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratornonemployeerelated4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratornonemployeerelated4(inputs)
});
export { settings_collaborators_invitecollaboratornonemployeerelated4 as "settings_collaborators_inviteCollaboratorNonEmployeeRelated" }